import React from 'react';

export interface CustomerTestimonialCardProps {
    text: string;
    author: string;
    style: {
        backgroundColor: string;
    };
}

const CustomerTestimonialCard = ({ text, author, style }: CustomerTestimonialCardProps) => {
    return (
        <pui-section backgroundcolor={style.backgroundColor} class='customer-testimonial-card'>
            <pui-text
                class='customer-testimonial-text'
                input={text}
                textalign='center'
                fontweight='bold'
                textsize='extra-large'
                paddingleft='med-small'
                paddingright='med-small'
                spacingtop='medium'
            ></pui-text>
            <pui-text
                class='customer-testimonial-author'
                input={author}
                textalign='center'
                fontweight='normal'
                textsize='medium'
                textcolor='med-grey'
                paddingleft='med-small'
                paddingright='med-small'
                spacingbottom='medium'
            ></pui-text>
        </pui-section>
    );
};

export default CustomerTestimonialCard;
